import PropTypes from 'prop-types';
import React from 'react';

const selectFilter = (options) => {
  const SelectFilterDropDownList = ({ filter, onChange }) => (
    <select
      onChange={(event) => onChange(event.target.value)}
      style={{ marginTop: '4px', width: '100%' }}
      value={filter ? filter.value : 'all'}
    >
      <option value="all">Show All</option>
      {options.length > 0 && options.map((o) => (
        <option key={o} value={o}>
          Category
          {o}
        </option>
      ))}
    </select>
  );
  SelectFilterDropDownList.propTypes = {
    filter: PropTypes.shape({
      value: PropTypes.string,
    }),
    onChange: PropTypes.func,
  };
  return SelectFilterDropDownList;
};

export default selectFilter;
